import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { Loader2, Plus, X } from 'lucide-react';
import { API } from '../../../lib/api';
import { useAuth } from '../../../contexts/AuthContext';
import { inputCls, formatErr } from '../billing/shared';

export const PurchaseOrderSettings = () => {
  const { authHeader } = useAuth();
  const [terms, setTerms] = useState(null);
  const [shipTo, setShipTo] = useState('');
  const [busy, setBusy] = useState(false); const [msg, setMsg] = useState(''); const [err, setErr] = useState('');
  useEffect(() => {
    axios.get(`${API}/billing/settings`, { headers: authHeader() }).then(({ data }) => {
      setTerms(data.po_terms || []); setShipTo(data.po_ship_to || '');
    }).catch(() => setTerms([]));
  }, []); // eslint-disable-line
  const save = async () => {
    setBusy(true); setMsg(''); setErr('');
    try {
      await axios.put(`${API}/billing/settings`, { po_terms: terms.map((t) => t.trim()).filter(Boolean), po_ship_to: shipTo.trim() }, { headers: authHeader() });
      setTerms(terms.filter((t) => t.trim())); setMsg('Saved.');
    } catch (e) { setErr(formatErr(e)); } finally { setBusy(false); }
  };
  if (!terms) return null;
  return (
    <section className="bg-white border border-slate-200 rounded-xl p-5 space-y-4" data-testid="po-settings-section">
      <div>
        <h2 className="text-sm font-semibold text-teal-700 uppercase tracking-wider">Purchase orders</h2>
        <p className="text-xs text-slate-500 mt-1">Printed on every purchase order you send to vendors.</p>
      </div>
      <div>
        <label className="block text-xs uppercase tracking-wider text-slate-500 mb-1">Default ship-to address</label>
        <textarea rows={2} value={shipTo} onChange={(e) => setShipTo(e.target.value)} placeholder="Leave blank to print 'Same as above'" className={inputCls} data-testid="po-ship-to-default" />
      </div>
      <div className="space-y-2">
        <label className="block text-xs uppercase tracking-wider text-slate-500">Terms &amp; conditions</label>
        {terms.map((t, i) => (
          <div key={i} className="flex items-start gap-2">
            <span className="pt-2 text-xs font-semibold text-slate-400 w-4">{i + 1}.</span>
            <textarea rows={2} value={t} onChange={(e) => setTerms(terms.map((x, j) => (j === i ? e.target.value : x)))} className={inputCls} data-testid={`po-term-${i}`} />
            <button type="button" onClick={() => setTerms(terms.filter((_, j) => j !== i))} className="pt-2 text-slate-400 hover:text-red-600" aria-label="Remove term" data-testid={`po-term-remove-${i}`}><X size={14} /></button>
          </div>
        ))}
        <button type="button" onClick={() => setTerms([...terms, ''])} className="inline-flex items-center gap-1 text-xs font-semibold text-teal-700 hover:text-teal-900" data-testid="po-term-add"><Plus size={13} /> Add a term</button>
      </div>
      {msg && <p className="text-xs text-emerald-700" data-testid="po-settings-ok">{msg}</p>}
      {err && <p className="text-xs text-red-700" data-testid="po-settings-error">{err}</p>}
      <button type="button" onClick={save} disabled={busy} className="inline-flex items-center gap-1.5 bg-teal-500 hover:bg-teal-600 disabled:bg-teal-300 text-white text-sm font-semibold px-4 py-2 rounded-lg" data-testid="po-settings-save">
        {busy && <Loader2 size={14} className="animate-spin" />} Save purchase order settings
      </button>
    </section>
  );
};
